var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CContainer',{staticClass:"tw-mt-4"},[_c('CAlert',{staticClass:"tw-text-lg",attrs:{"variant":"warning"}},[_vm._v(_vm._s(_vm.error.message))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }